import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-file-minus-icon',
  templateUrl: './files-file-minus.component.html'
})
export class FilesFileMinusComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
